export enum Caches {
  VERIFY_IF_TASK_HAS_BEEN_COMPLETED = 'completedTasks',
  MENU = 'globalMenu',
  FOOTER = 'globalFooter',
}
